export default "__VITE_ASSET__CXnyVrsJ__"